// src/nexoClient.js
// Instancia principal del SDK Nexo para comunicación con el Admin de Tiendanube
// Más info: https://dev.tiendanube.com/docs/developer-tools/nexo

import nexo from '@tiendanube/nexo';

// El clientId debe ser el App ID de tu aplicación en Tiendanube
// Puedes moverlo a una variable de entorno si lo prefieres
const clientId = process.env.REACT_APP_TN_CLIENT_ID || '18380';

const nexoClient = nexo.create({
  clientId,
  log: process.env.NODE_ENV !== 'production',
});

export default nexoClient;
